{
	"language": {
		"select": "Piliin ang wika",
		"sectionTitle": "Wika",
		"changeSuccess": "Matagumpay na nabago ang wika"
	},
	"assistant": {
		"composer": {
			"placeholder": "Magtanong kay {{assistantName}}",
			"disclaimer": "Puwedeng magkamali ang {{assistantName}}. Suriin ang mahahalagang impormasyon."
		},
		"greeting": {
			"initialMessage": "👋 Hi, ako ang **{{assistantName}}**, ang iyong katuwang sa pag-aaral, at nandito ako para tulungan kang mas maghanda para sa **{{context}}!** Suriin natin nang mas malalim ang item na sinagot mo tungkol sa **{{topic}}.**",
			"starter": "Hi, ako si **{{assistantName}}**. Paano kita matutulungan?"
		},
		"chips": {
			"askYourOwn": "Magtanong ng sarili mong tanong",
			"askFollowUp": "Magtanong ng karagdagang tanong"
		},
		"emptyState": {
			"title": "Ang {{assistantName}} ay ang iyong katuwang sa pag-aaral na pinapagana ng AI",
			"contextSubtitle": "Magtanong ng kahit ano na may kaugnayan sa {{context}}",
			"activateSubtitle": "Mag-a-activate ang {{assistantName}} pagkatapos mong sagutan ang tanong"
		}
	},
	"dashboard": {
		"header": {
			"quickStudy": "Quick Study",
			"examInfo": {
				"subtitle": {
					"setExamDate": "Itakda ang petsa ng exam",
					"examDateWithValue": "Petsa ng exam: <date>{{date}}</date>"
				}
			}
		},
		"reviewPrompt": {
			"buttons": {
				"couldBeBetter": "Puwede pang mas maganda",
				"itsAwesome": "Ang galing!"
			},
			"title": "Sobrang sipag mo ngayon!",
			"body": "Natutuwa kami sa iyong dedikasyon sa pag-aaral! Kumusta ang experience mo sa app sa ngayon? Gusto mo bang ibahagi ang iyong opinyon sa pamamagitan ng review?",
			"cta": "Sa ibang pagkakataon na lang"
		},
		"actions": {
			"studyWeak": "Pagtuunan ng pansin ang mahihinang bahagi",
			"viewProgress": "Tingnan ang iyong progreso",
			"seeRank": "Tingnan ang iyong ranggo",
			"seeRankings": "Tingnan ang leaderboard",
			"unlock": "I-unlock ang premium content",
			"unlockTooltip": "Magkaroon ng access sa mga eksklusibong feature at advanced na materyal sa pag-aaral sa pamamagitan ng pag-unlock ng premium content",
			"startCustomSession": "Gumawa ng pasadyang session",
			"startCustomSessionTooltip": "Magsimula ng pasadyang study session para pagtuunan ng pansin ang partikular na bahagi ng iyong pag-aaral",
			"takeDiagnostic": "Kumuha ng diagnostic",
			"takeDiagnosticTooltip": "Kumuha ng diagnostic para masuri ang iyong kasalukuyang level at iakma ang iyong study plan",
			"viewDiagnostic": "Tingnan ang resulta ng diagnostic",
			"viewDiagnosticTooltip": "Tingnan ang resulta ng iyong diagnostic para makita ang iyong mga kalakasan at mga bahaging dapat pang paunlarin",
			"viewPodcasts": "Makinig sa mga podcast",
			"viewPodcastsTooltip": "Magkaroon ng access sa mga edukasyonal na podcast para mapahusay ang iyong karanasan sa pag-aaral",
			"upgradeToPremium": "Mag-upgrade sa premium",
			"upgradeToPremiumTooltip": "Mag-upgrade sa premium para ma-access ang lahat ng content at feature",
			"extendAccess": "Palawigin ang access",
			"extendAccessTooltip": "Palawigin ang iyong access sa premium content at feature",
			"setExamDate": "Itakda ang petsa ng exam",
			"setExamDateTooltip": "Itakda ang petsa ng iyong exam para masubaybayan ang iyong progreso at maghanda para sa iyong exam"
		},
		"exam": {
			"daysAgo_one": "{{count}} araw na ang nakalipas",
			"daysAgo_other": "{{count}} araw na ang nakalipas",
			"untilExam_one": "{{count}} araw na lang hanggang sa exam",
			"untilExam_other": "{{count}} araw na lang hanggang sa exam",
			"isToday": "Ngayon na ang exam!"
		},
		"stats": {
			"mastery": "Pagkabihasa",
			"completed_one": "Item na nasagutan",
			"completed_other": "Item na nasagutan",
			"completedValue": "{{count}}",
			"xpEarned": "Nakuhang XP",
			"xpEarnedValue": "{{value}}",
			"accuracy": "Katumpakan",
			"accuracyValue": "{{value}}%",
			"skillLevelTooltip": "Ang tinatayang kahusayan mo sa {{skill, lowercase}} ay {{level, lowercase}}",
			"itemsAnsweredTooltip": "Kabuuang bilang ng item na nasagutan mo sa ngayon",
			"responsesAnsweredTooltip": "Kabuuang bilang ng sagot na naisumite mo sa ngayon",
			"examDateTooltip": "Ang exam mo ay sa {{date}}",
			"skillCta": {
				"diagnostic": "Diagnostic",
				"practice": "Magsanay"
			}
		},
		"menu": {
			"settings": "Setting",
			"profile": "Tungkol sa iyo"
		},
		"diagnostics": {
			"title": "Mga Diagnostic",
			"free": "Libre",
			"duration": "{{count}} {{item}} • {{minutes}} minuto",
			"completed": "{{count}} {{item}} na nakumpleto",
			"start": "Simulan",
			"viewReport": "Tingnan ang report",
			"resume": "Ipagpatuloy"
		},
		"practiceTests": {
			"title": "Practice Tests",
			"sectionalTestsTitle": "Sectional Tests",
			"diagnosticAssessmentsTitle": "Diagnostic Assessments",
			"premiumChipTooltip": "Buong-haba, premium na practice test para sa {{examName}} exam",
			"freeChipTooltip": "{{label}} para sa {{examName}} exam",
			"freeChipTooltipDefault": "Libreng diagnostic assessment para sa {{examName}} exam",
			"completedDescription_one": "{{count}} na item • {{date}}",
			"completedDescription_other": "{{count}} na item • {{date}}",
			"activeDescription_one": "{{attempted}}/{{count}} item • {{timeRemaining}} natitira",
			"activeDescription_other": "{{attempted}}/{{count}} item • {{timeRemaining}} natitira",
			"activeDescriptionWithDates_one": "{{attempted}}/{{count}} item • {{timeRemaining}} natitira • Sinimulan noong: {{startedOn}} • Magtatapos sa: {{endsOn}}",
			"activeDescriptionWithDates_other": "{{attempted}}/{{count}} item • {{timeRemaining}} natitira • Sinimulan noong: {{startedOn}} • Magtatapos sa: {{endsOn}}",
			"notStartedDescription_one": "{{count}} na item • {{duration}}",
			"notStartedDescription_other": "{{count}} na item • {{duration}}",
			"notStartedDescriptionWithEnd_one": "{{count}} item • {{duration}} • Magtatapos sa: {{endsOn}}",
			"notStartedDescriptionWithEnd_other": "{{count}} item • {{duration}} • Magtatapos sa: {{endsOn}}",
			"viewResultsCta": "Tingnan ang resulta",
			"startCta": "Simulan",
			"chips": {
				"items_one": "{{count}} item",
				"items_other": "{{count}} item",
				"progress_one": "{{attempted}} sa {{count}} item",
				"progress_other": "{{attempted}} sa {{count}} item",
				"timeRemaining": "{{time}} natitira",
				"startedOn": "Sinimulan noong {{date}}",
				"endsOn": "Magtatapos sa {{date}}",
				"timeLeft": "{{time}} na lang"
			},
			"status": {
				"notStarted": {
					"label": "Hindi pa nasimulan",
					"section": "Buong-Haba na Practice Tests"
				},
				"inProgress": {
					"label": "Isinasagawa",
					"section": "Isinasagawa"
				},
				"completed": {
					"label": "Nakumpleto na",
					"section": "Nakumpleto na"
				},
				"legacyReports": {
					"label": "Lumang mga report",
					"section": "Lumang mga report"
				},
				"migratedReports": {
					"label": "Nailipat na mga report",
					"section": "Nailipat na mga report"
				}
			}
		},
		"skills": {
			"title": "Mga Kasanayan",
			"unlockSubtitle": "I-unlock ang premium para makapagsanay",
			"startCta": "Magsanay",
			"freeItemsIncludedChip": "Kasama ang mga libreng item",
			"freeItemsAnsweredSubtitle_one": "{{answered, number}} sa {{count, number}} libreng item ang nasagutan",
			"freeItemsAnsweredSubtitle_other": "{{answered, number}} sa {{count, number}} libreng item ang nasagutan",
			"progressCards": {
				"questionTypesTitle": "Pagganap ayon sa uri ng tanong",
				"questionTypesSubtitle": "Ang iyong score sa iba't ibang uri ng tanong sa {{skill}}",
				"proficiencyTitle": "Pagganap ayon sa kahusayan",
				"proficiencySubtitle": "Ang iyong progreso sa mga level ng {{skill}}",
				"questionTypeCardSubtitle": "Progreso ayon sa level ng kahusayan",
				"bySkillTitle": "Pagganap ayon sa kasanayan",
				"bySkillSubtitle": "Kabuuang progreso sa mga kasanayan",
				"needsImprovementTitle": "Kailangan pang paunlarin",
				"needsImprovementSubtitle": "Mga paksang dapat pagtuunan ng pansin",
				"skillPerformanceTitle": "Pagganap sa {{skill}}",
				"skillPerformanceSubtitle": "Progreso ayon sa uri ng tanong at kahusayan",
				"skillLevelSubtitle": "Ang iyong progreso sa level na ito ng kasanayan",
				"skillsPerformanceTitle": "Pagganap ng Mga Kasanayan",
				"performanceByItemDifficulty": "Pagganap ayon sa kahusayan ng item",
				"performanceByItemDifficultyCaption_one": "Ipinapakita ang iyong katumpakan ayon sa level ng kahusayan, base sa {{count}} item na nasagutan",
				"performanceByItemDifficultyCaption_other": "Ipinapakita ang iyong katumpakan ayon sa level ng kahusayan, base sa {{count}} item na nasagutan",
				"questionTypePartSubtitle": "{{skill}} · Bahagi {{part}}",
				"activityGoalTitle": "Progreso ng Aktibidad at Layunin",
				"recentActivityTitle": "Kamakailang Aktibidad",
				"goalProgressTitle": "Progreso ng Layunin",
				"goalProgressSubtitle": "Kabuuang score · Nakaraang 7 na linggo",
				"goalProgressInsight": "Unti-unti kang umuunlad. Mas mababa ka nang 14 puntos sa iyong tunguhin at posibleng maabot mo ang iyong layunin sa loob ng humigit-kumulang 3 linggo.",
				"goalProgressActualLabel": "Ang iyong score",
				"goalProgressTargetLabel": "Tunguhin",
				"goalProgressTimeAxisLabel": "Oras",
				"goalProgressScoreAxisLabel": "Kabuuang Progreso",
				"statusTitle": "Ang Iyong Status",
				"diagnosticsTitle": "Mga Diagnostic",
				"diagnosticsReviewCta": "I-review",
				"strengthsFocusTitle": "Kalakasan at Mga Dapat Pagtuunan",
				"strengthsFocusSubtitle": "Ang iyong pinakamalakas na larangan at ang mga uri ng tanong na kailangan pang sanayin",
				"strengthsLabel": "Kalakasan",
				"focusAreasLabel": "Mga Dapat Pagtuunan",
				"recommendedNextStepLabel": "Inirerekomendang Susunod na Hakbang",
				"recommendedNextStepCta": "Simulan",
				"practiceTestsViewMore": "Tingnan lahat ng {{count}} test"
			},
			"proficiencySection": "Magsanay ayon sa level ng kahusayan"
		},
		"recommendedTasks": {
			"sectionTitle": "Inirerekomenda para sa iyo",
			"startSessionAction": "Magsanay",
			"resumeAction": "Ipagpatuloy",
			"reviewResultsAction": "I-review ang mga resulta",
			"startTestAction": "Simulan",
			"activeTestBody": "Kumpletuhin ang iyong isinasagawang assessment",
			"completedTestBody": "I-review ang iyong mga resulta at personalized na mga pananaw",
			"diagnosticBody": "Sagutan ang {{label}} para makakuha ng baseline at maging pamilyar sa format ng exam",
			"diagnosticDefaultLabel": "libreng diagnostic",
			"practiceTestBody": "Suriin ang iyong kahandaan gamit ang naka-oras na mock exam",
			"sectionalTestBody": "Sagutan ang isang nakatuong test para magsanay sa iyong mga kasanayan sa {{skills}}",
			"weakSkillTitle": "Paunlarin ang iyong mga kasanayan sa {{skill}}",
			"weakSkillBody": "Pagsasanay sa {{questionType}}, nakatuon sa mga kailangan mong pagbutihin",
			"strongSkillTitle": "Panatilihing matalas ang iyong mga kasanayan sa {{skill}}",
			"strongSkillBody": "Panatilihin ang iyong mga kalakasan sa {{questionType}} gamit ang karagdagang pagsasanay",
			"mixedSkillTitle": "Pagbutihin ang iyong mga kasanayan sa {{skill}}",
			"mixedSkillBody": "Magsanay sa mga uri ng tanong tulad ng {{questionTypes}}, na nakatuon sa mga kailangan mong pagbutihin",
			"higherDifficultySkillTitle": "Mag-level up patungo sa {{proficiency}}",
			"higherDifficultySkillBody": "Ngayong magaling ka na sa {{questionType}}, panahon na para taasan ang antas ng hirap",
			"itemsChip_one": "{{count}} item",
			"itemsChip_other": "{{count}} item",
			"timeRemainingChip": "{{minutes}} min na natitira",
			"timeRemainingChipCompact": "{{minutes}} minuto"
		},
		"itemTypes": {
			"answeredLabel_one": "Item na nasagutan",
			"answeredLabel_other": "Item na nasagutan",
			"answeredAll": "Lahat",
			"answeredPartial": "{{answered}} sa {{total}}",
			"cardSubtitleComplete": "Nasagutan na ang lahat ng item",
			"cardSubtitlePartial": "{{attempted}} sa {{total}} item ang nasagutan",
			"cardSubtitleResponses_one": "{{count}} sagot",
			"cardSubtitleResponses_other": "{{count}} sagot",
			"responsesLabel_one": "Sagot",
			"responsesLabel_other": "Sagot",
			"detail": {
				"skillLabel": "Kasanayan",
				"estimatedLevelLabel": "Tinatayang level"
			}
		},
		"tagSections": {
			"summary": "{{tagCount, number}} {{label, lowercase}} • $t(common.itemCount, {\"count\": {{itemCount}} })",
			"summaryWithoutItemCount": "{{tagCount, number}} {{label, lowercase}}",
			"responseCount_one": "{{count, number}} sagot",
			"responseCount_other": "{{count, number}} sagot"
		},
		"studyPack": {
			"freeContentBannerTitle_one": "Kasama ang {{count, number}} libreng practice item",
			"freeContentBannerTitle_other": "Kasama ang {{count, number}} libreng practice item",
			"freeContentBannerBody": "Magsanay gamit ang mga piling {{skills}} item anumang oras. Mag-upgrade para i-unlock ang kumpletong Pakete ng Pag-aaral.",
			"freeContentBannerCta": "Simulan ang libreng pagsasanay"
		}
	},
	"appbar": {
		"leaderboard": {
			"description": "Tingnan kung saan ka nakatayo kumpara sa iba"
		},
		"home": {
			"title": "Bahay"
		},
		"podcasts": {
			"description": "Makinig sa mga ortopedikong podcast na pinangunahan ng mga eksperto."
		},
		"more": {
			"title": "Higit Pang Setting"
		}
	},
	"emptyState": {
		"progress": {
			"title": "Wala pang progreso sa pag-aaral",
			"subtitle": "Habang nag-aaral ka, lalabas dito ang iyong progreso",
			"cta": "Mag-aral na"
		}
	},
	"errors": {
		"sessionCreation": {
			"title": "Pagkakamali",
			"body": "Nabigo ang paggawa ng session, pakisubukan ulit"
		}
	},
	"mastery": {
		"labels": {
			"advanced": "Mahusay",
			"highIntermediate": "Katamtaman",
			"intermediate": "Katamtaman",
			"basic": "Batayan",
			"none": "Hindi nasagutan",
			"high": "Bihasa",
			"medium": "Malapit na",
			"low": "Kailangan pang sanayin"
		}
	},
	"leaderboard": {
		"you": "Ikaw ito",
		"periods": {
			"all_time": "Lahat ng panahon",
			"month": "Ngayong buwan",
			"week": "Ngayong linggo"
		},
		"scope": {
			"global": "Pandaigdig",
			"friends": "Mga kaibigan"
		},
		"friends": {
			"soon": "MALAPIT NA",
			"comingSoonTitle": "Leaderboard ng mga kaibigan",
			"comingSoonBadge": "Malapit na",
			"comingSoonDescription": "Subaybayan ang iyong progreso kumpara sa mga kaibigan at tingnan kung sino ang nasa tuktok ng klase."
		},
		"error": {
			"title": "Pagkakamali sa koneksyon",
			"description": "Hindi ma-load ang leaderboard. Suriin ang iyong koneksyon at subukan ulit.",
			"tryAgain": "Subukan ulit"
		},
		"empty": {
			"title": "Wala pang mga lider",
			"description": "Nag-a-update ang mga ranggo habang mas maraming tao ang nag-aaral. Maging una kang kumita ng XP at angkinin ang pinakamataas na puwesto!",
			"startLearning": "Mag-aral na"
		},
		"topPerformers": "Mga nangunguna",
		"yourPosition": "Ang iyong puwesto",
		"rankings": "Mga ranggo",
		"rankingsRange": "Mga ranggo • #{{startRank}}–{{endRank}}",
		"unranked": {
			"title": "Kumita ng XP para sumali sa ranggo!",
			"description": "Magsimula ng study session para kumita ng iyong unang puntos at sumali sa leaderboard.",
			"cta": "Simulan ang iyong unang session"
		},
		"xpAmount": "<num>{{value}}</num> <unit>XP</unit>",
		"youBadge": "Ikaw",
		"podium": {
			"first": "1st",
			"second": "2nd",
			"third": "3rd"
		},
		"footer": {
			"gapHintToPass": "<num>+{{value}}</num><unit> XP</unit> <rest>para lampasan ang #{{rank}}</rest>",
			"gapHintFromPodium": "<num>{{value}}</num><unit> XP</unit> <rest>mula sa podium</rest>"
		}
	},
	"lessons": {
		"explore": {
			"title": "Mga aralin",
			"searchPlaceholder": "Maghanap ng aralin",
			"count_one": "{{count}} Aralin",
			"count_other": "{{count}} Aralin",
			"sortModalTitle": "Ayusin ang mga aralin",
			"filterModalTitle": "I-filter ayon sa mga paksa",
			"sort": {
				"popularity": "Kasikatan",
				"popularityShort": "Sikat",
				"topic": "Paksa",
				"difficulty": "Antas ng hirap",
				"recent": "Kamakailang na-update",
				"recentShort": "Na-update",
				"completed": "Nakumpleto na"
			},
			"chips": {
				"all": "Lahat",
				"recent": "Kamakailang na-update",
				"completed": "Nakumpleto na",
				"premium": "Premium",
				"topics": "Mga paksa",
				"topicsCount_one": "{{count}} paksa",
				"topicsCount_other": "{{count}} paksa"
			},
			"chipTooltips": {
				"all": "Ipakita ang lahat ng aralin.",
				"recent": "Ipakita ang mga pinakabagong na-update na aralin.",
				"completed": "Ipakita ang mga nakumpletong aralin.",
				"premium": "Ipakita ang mga premium na aralin.",
				"topics": "I-filter ang mga aralin ayon sa paksa."
			},
			"filterNames": {
				"premium": "premium",
				"completed": "nakumpleto",
				"topics": "paksa"
			},
			"empty": {
				"searchTitle_one": "{{count}} aralin ang itinago ng paghahanap",
				"searchTitle_other": "{{count}} aralin ang itinago ng paghahanap",
				"searchSubtitle": "Subukan ang ibang mga salita o i-clear ang iyong paghahanap",
				"searchCta": "I-clear ang paghahanap",
				"filtersTitle_one": "{{count}} aralin ang itinago ng mga filter",
				"filtersTitle_other": "{{count}} aralin ang itinago ng mga filter",
				"filtersSubtitle_one": "Alisin ang {{filters}} filter para makakita ng higit pa",
				"filtersSubtitle_other": "Alisin ang {{filters}} filter para makakita ng higit pa",
				"filtersCta": "I-clear lahat ng filter",
				"noneTitle": "Walang nahanap na aralin",
				"noneSubtitle": "Subukang alisin ang mga filter o magsimula ng bagong paghahanap",
				"noneCta": "I-reset lahat"
			}
		},
		"home": {
			"settings": {
				"a11yLabel": "Buksan ang mga setting"
			},
			"continueLearning": {
				"title": "Ipagpatuloy ang pag-aaral"
			},
			"suggested": {
				"title": "Iminumungkahi para sa iyo"
			},
			"completed": {
				"title": "Nakumpleto na"
			},
			"all": {
				"title": "Lahat ng aralin"
			},
			"emptyState": {
				"title": "Wala pang aralin",
				"subtitle": "Bumalik sa lalong madaling panahon para sa mga bagong aralin."
			},
			"card": {
				"resumeCta": "Ipagpatuloy",
				"progress": "{{value}}% kumpleto",
				"timeLeft_one": "{{count}} minuto na natitira",
				"timeLeft_other": "{{count}} minuto na natitira",
				"duration_one": "{{count}} minuto",
				"duration_other": "{{count}} minuto"
			}
		},
		"overview": {
			"header": {
				"title": "Pangkalahatang-ideya"
			},
			"startCta": "Simulan ang pag-aaral",
			"objectives": {
				"title": "Mga layunin sa pag-aaral"
			}
		},
		"detail": {
			"takeQuizCta": "Sagutan ang quiz",
			"progress": {
				"label": "Progreso ng modyul"
			},
			"activities": {
				"title": "Mga gawain",
				"completedCount": "{{completed}} sa {{total}} ang nakumpleto"
			},
			"artifact": {
				"completed": "Nakumpleto na",
				"locked": "Naka-lock"
			}
		},
		"stats": {
			"insights": {
				"title": "Mga pananaw sa progreso"
			},
			"overallProgress": {
				"title": "Kabuuang progreso",
				"completedCount_one": "{{completed}} sa {{count}} item ang nakumpleto",
				"completedCount_other": "{{completed}} sa {{count}} item ang nakumpleto"
			},
			"milestones": {
				"title": "Mga yugto ng modyul"
			}
		},
		"studyGuide": {
			"sectionBadge": {
				"label": "Seksyon {{number}} ng {{total}}"
			},
			"upNext": {
				"title": "Susunod"
			}
		}
	},
	"sessionConfig": {
		"title": "Pasadyang study session",
		"diagnostic": "Diagnostic",
		"skill": "Mga kasanayan",
		"Proficiency": "Kahusayan",
		"Question Type": "Mga uri ng tanong",
		"mastery": "Pagkabihasa",
		"sessionLength": "Tagal ng session",
		"itemsChip_one": "{{count}} item",
		"itemsChip_other": "{{count}} item",
		"durationEstimate": "{{minutes}} minuto",
		"durationRange": "{{min}}–{{max}} minuto",
		"noItemsTooltip": "Walang item na tumutugma sa kasalukuyang mga filter",
		"setCount": "{{count}} {{type}}",
		"dismiss": "Ok",
		"status": {
			"notAnswered": "Hindi nasagutan",
			"needsWork": "Kailangan pang sanayin"
		},
		"itemCount": "Makukumpleto mo ang {{count}} item mula sa {{topics}}",
		"start": "Simulan ang session",
		"configuringSession": "Kinukumpigura ang session",
		"fetchingContent": "Kinukuha ang content",
		"preparingMaterials": "Inihahanda ang mga materyal",
		"almostThere": "Malapit na",
		"startingSession": "Sinisimulan ang session",
		"playIcon": "play-outline",
		"infoText": "Makukumpleto mo ang **{{numItems}}** {{itemCount}}. Aabutin ito ng humigit-kumulang **{{timeString}}**.",
		"customSummary": {
			"message": "Mag-aral ng $t(sessionConfig.customSummary.itemCount, {\"count\": {{count}}}) mula sa {{topics}}.",
			"messageWithMastery": "Mag-aral ng $t(sessionConfig.customSummary.itemCount, {\"count\": {{count}}}) mula sa {{topics}}, na nakatuon sa {{masteryLevels}} $t(sessionConfig.customSummary.masteryLevelCount, {\"count\": {{masteryCount}}}).",
			"messageAllMasteryLevels": "Mag-aral ng $t(sessionConfig.customSummary.itemCount, {\"count\": {{count}}}) mula sa {{topics}} sa lahat ng antas ng pagkabihasa.",
			"itemCount_one": "{{count}} item",
			"itemCount_other": "{{count}} item",
			"masteryLevelCount_one": "antas ng pagkabihasa",
			"masteryLevelCount_other": "antas ng pagkabihasa",
			"allTopics": "lahat ng {{count}} paksa",
			"more": "{{count}} pa",
			"quotedMasteryLevel": "“{{masteryLevel}}”"
		},
		"quickStudy": {
			"title": "Mabilisang Pag-aaral",
			"recommended": "Inirerekomenda",
			"custom": "Pasadya",
			"selectHelper": "I-tap ang isang session para piliin ito, pagkatapos ay magsimula kapag handa ka na.",
			"emptyRecommended": "Wala pang magagamit na inirerekomendang session sa ngayon.",
			"summary": "Mag-aral ng {{count}} item mula sa {{skill}}. Tinatayang {{minutes}} minuto.",
			"summary_questionType": "Mag-aral ng {{count}} item mula sa {{skill}}, {{questionType}}. Tinatayang {{minutes}} minuto.",
			"duration": "{{minutes}} minuto",
			"durationSelector": {
				"title": "Tagal"
			},
			"levelSessions": {
				"rapidRecall": "Mabilisang pag-alala",
				"purposefulPractice": "May-layuning pagsasanay",
				"focusFlow": "Daloy ng pokus",
				"itemsLabel": "{{level}} item",
				"itemsLabelGeneric": "item",
				"summaries": {
					"rapidRecall": "Magkaroon ng mabilisang exposure sa {{count}} {{level}} item na hindi mo pa nasagutan para unti-unting lumawak ang iyong coverage. Tinatayang {{minutes}} minuto.",
					"purposefulPractice": "Sagutan ang isang balanced na set ng {{count}} {{level}} item, simula sa mga bahaging pinaka-kailangan mong sanayin. Tinatayang {{minutes}} minuto.",
					"focusFlow": "Palakasin ang iyong mahihinang bahagi gamit ang {{count}} {{level}} item na nasagutan mo nang may mababa o katamtamang pagkabihasa. Tinatayang {{minutes}} minuto."
				},
				"summariesGeneric": {
					"rapidRecall": "Magkaroon ng mabilisang exposure sa {{count}} item na hindi mo pa nasagutan para unti-unting lumawak ang iyong coverage. Tinatayang {{minutes}} minuto.",
					"purposefulPractice": "Sagutan ang isang balanced na set ng {{count}} item, simula sa mga bahaging pinaka-kailangan mong sanayin. Tinatayang {{minutes}} minuto.",
					"focusFlow": "Palakasin ang iyong mahihinang bahagi gamit ang {{count}} item na nasagutan mo nang may mababa o katamtamang pagkabihasa. Tinatayang {{minutes}} minuto."
				}
			},
			"lockedOptionsBanner": "I-unlock ang {{names}} gamit ang Premium",
			"lockedOptionsBannerOverflow": "I-unlock ang {{names}} at {{count}} pa gamit ang Premium"
		}
	},
	"skillDetail": {
		"diagnosticInsight": "Para i-personalize ang iyong karanasan, magsimula sa isang diagnostic quiz. Gagamitin ang mga resulta ng iyong diagnostic para gawin ang iyong study plan."
	},
	"premium": {
		"chip": "Premium",
		"upgrade": "Mag-upgrade sa premium",
		"unlockTitle": "I-unlock ang iyong kumpletong karanasan sa {{productName}}",
		"unlockDescription": "I-unlock ang personalized na pagsasanay na idinisenyo batay sa natitirang oras mo sa pag-aaral.",
		"readyTitle": "Maging handa para sa iyong exam sa {{date}}",
		"tip": "Ang iyong personalized na focus, tinutukoy ng premium kung ano ang susunod mong pagsasanayan at inaayos ang iyong study plan habang umuunlad ka."
	},
	"purchase": {
		"success": {
			"headerTitle": "Salamat sa iyong pagbili!",
			"accessGranted": "Matagumpay na naibigay ang access sa iyong {{name}}",
			"studyPack": "Pakete ng Pag-aaral",
			"practiceTest": "Practice Test",
			"combo": "Kumbinasyon",
			"documentTitle": "Pagbili",
			"summary_one": "Binabati kita! Na-unlock na ang **produkto** sa ibaba sa iyong account. Pagkatapos pindutin ang {{action}}, mababago ang konteksto ng iyong app para ipakita ang exam: **{{examName}}**. Puwede mong baguhin ito anumang oras mula sa setting ng iyong account kung gusto mong mag-aral para sa ibang exam o bumili ng ibang product.",
			"summary_other": "Binabati kita! Na-unlock na ang **{{count}} product** sa ibaba sa iyong account. Pagkatapos pindutin ang {{action}}, mababago ang konteksto ng iyong app para ipakita ang exam: **{{examName}}**. Puwede mong baguhin ito anumang oras mula sa setting ng iyong account kung gusto mong mag-aral para sa ibang exam o bumili ng ibang product.",
			"unlockedDuration": "Binabati kita! Na-unlock mo ang **{{duration}}** na access sa **{{name}}**. Mag-e-expire ito sa **{{expiry}}**.",
			"storeNote": "Tandaan: Ang mga Pakete ng Pag-aaral ay maa-access lang sa aming mga mobile app. Mangyaring i-download ang app na akma sa iyong device.",
			"actions": {
				"goToHome": "Pumunta sa home",
				"startDiagnostic": "Simulan ang {{label}}",
				"takeDiagnostic": "Kunin ang {{label}}",
				"takeFreeDiagnostic": "Kunin ang libreng diagnostic",
				"diagnosticLabel": "diagnostic"
			}
		},
		"checkout": {
			"headerTitle": "Kumpletuhin ang iyong pagbili"
		},
		"paywall": {
			"studyPackDialogTitle": "I-upgrade ang iyong study plan",
			"defaultDialogTitle": "I-upgrade ang iyong study plan",
			"practiceTestDialogTitle": "I-unlock ang mga practice test",
			"restorePurchaseDialogTitle": "Bumili ka na ba?",
			"restorePurchaseDialogSubheadingWeb": "Kung hindi, subukan ito:",
			"restorePurchaseDialogBody": "Kung nabili mo na ang product na ito pero naka-lock pa rin ito, subukan ang mga sumusunod:\n\n1. Tiyakin na naka-login ka sa tamang account\n2. Tiyakin na napili mo ang tamang product\n3. Tiyakin na hindi pa nawalan ng bisa ang iyong subscription\n4. Tiyakin na na-activate mo na ang iyong subscription (tingnan ang iyong junk mail)\n5. Kung mayroon kang access code, [access code]({{baseUrl}}/redeem)\n\nKung wala sa mga ito ang naaangkop, mangyaring **i-click dito**",
			"restorePurchaseDialogBodyWeb": "1. Tiyakin na naka-login ka sa tamang email\n2. Tiyakin na tama ang **[napiling exam](/account/settings)**\n3. Tiyakin na hindi pa nawalan ng bisa ang iyong subscription\n\nKung wala sa mga ito ang naaangkop, mangyaring **makipag-ugnayan sa suporta**",
			"accesDuration": {
				"yearPlan": "Nagbibigay ang **{{duration}}** na plan ng mas mahabang access, para sa pinakamataas na flexibility na mag-aral sa sarili mong bilis at lubusang maghanda para sa iyong exam.",
				"moreTime": "Kung sa tingin mo kakailanganin mo ng mas maraming oras para mag-aral, puwede mong isaalang-alang ang **{{duration}}** na plan.",
				"otherPlan": "Bibigyan ka ng **{{duration}}** na plan ng access hanggang **{{expiryText}}**, na sapat na oras para mag-aral. {{moreTime}}"
			},
			"actions": {
				"upgrade": "Mag-upgrade",
				"unlock": "I-unlock para sa {{price}}",
				"subscribe": "Mag-subscribe para sa {{price}}",
				"extendAccess": "Palawigin ang access",
				"accessHere": "I-access dito",
				"redeemAccessCode": "May access code ka?",
				"restorePurchase": "Bumili ka na ba?",
				"restorePurchaseWeb": "Bumili ka na ba o may access code ka?"
			},
			"subscriptionSummary": {
				"yearly": "Yearly subscription • Awtomatikong nagre-renew • Kanselahin anumang oras",
				"monthly": "Monthly subscription • Awtomatikong nagre-renew • Kanselahin anumang oras",
				"weekly": "Weekly subscription • Awtomatikong nagre-renew • Kanselahin anumang oras",
				"generic": "Awtomatikong nagre-renew na subscription • Kanselahin anumang oras"
			},
			"planDuration": {
				"day_one": "{{count}} araw",
				"day_other": "{{count}} araw",
				"week_one": "{{count}} linggo",
				"week_other": "{{count}} linggo",
				"month_one": "{{count}} buwan",
				"month_other": "{{count}} buwan",
				"year_one": "{{count}} taon",
				"year_other": "{{count}} taon"
			},
			"recommendedPlan": {
				"plan": "Inirerekomenda namin ang \"**{{duration}}**\" na plan para pinakamahusay na makapaghanda ka para sa iyong exam sa **{{date}}**",
				"subscription": {
					"yearly": "Inirerekomenda namin ang **yearly subscription** para sa tuluy-tuloy na access at paghahanda para sa iyong exam sa **{{date}}**",
					"monthly": "Inirerekomenda namin ang **monthly subscription** para sa tuluy-tuloy na access at paghahanda para sa iyong exam sa **{{date}}**",
					"weekly": "Inirerekomenda namin ang **weekly subscription** para sa tuluy-tuloy na access at paghahanda para sa iyong exam sa **{{date}}**",
					"generic": "Inirerekomenda namin ang **subscription** para sa tuluy-tuloy na access at paghahanda para sa iyong exam sa **{{date}}**"
				}
			},
			"disclaimer": "Kapag nakumpirma na ang pagbili, bibigyan ka ng buong access sa content ng product na ito para sa napiling tagal. Kapag nag-expire ang panahong ito, mawawalan ka ng access sa restricted na content. Kung gusto mong palawigin ang iyong access sa anumang dahilan (hal., nagbago ang petsa ng iyong exam), puwede kang magdagdag ng oras sa pamamagitan ng karagdagang in-app purchase. Para sa karagdagang impormasyon, tingnan ang aming [Mga Tuntunin ng Serbisyo at Patakaran sa Pagkapribado](https://memorang.com/legal)."
		}
	},
	"progress": {
		"tagProgress": {
			"subtitle": "Batay sa {{numItems}} {{item}} na nasagot sa {{count}} {{type}}",
			"itemCount": "{{count}} {{item}}",
			"tooltip": "Ipinapakita nito ang iyong progreso sa {{count}} {{type}}. Batay ito sa {{itemCount}} {{item}} na nasagot mo sa ngayon."
		},
		"needsImprovement": {
			"title": "Kailangan pang pagbutihin",
			"subtitle": "Inirerekomendang {{type}} para higit mo pang mapabuti",
			"cta": "Mag-aral na"
		},
		"mastery": {
			"high": "Bihasa",
			"medium": "Malapit na",
			"low": "Kailangan pang sanayin",
			"count": "{{count}} {{item}} na nasagot",
			"zeroTooltip": "Wala pang {{label}} na item sa {{total}} item na nasagot",
			"highTooltip": "Bihasa ka na sa {{count}} sa {{total}} {{item}} na nasagot",
			"mediumTooltip": "Umuunlad ka sa {{count}} sa {{total}} {{item}} na nasagot",
			"lowTooltip": "Kailangan mo pa ng pagsasanay sa {{count}} sa {{total}} {{item}} na nasagot"
		},
		"stats": {
			"completion": "Pagkumpleto",
			"completionCount": "{{completed}}/{{total}} {{item}}",
			"completionTooltip": "Nakumpleto mo na ang {{completed}} sa {{total}} {{item}}"
		},
		"exams": {
			"title": "Practice Tests",
			"subtitle_one": "Batay sa {{count}} kumpletong assessment",
			"subtitle_other": "Batay sa {{count}} kumpletong assessment"
		},
		"summary": {
			"title": "Buod ng pag-aaral",
			"subtitle": "Batay sa {{count}} {{item}} na nasagot",
			"tooltip": "Ipinapakita ng buod na ito ang iyong mga mastery level at progreso ng pagkumpleto sa kabuuang {{count}} {{item}}. Sinusukat ang iyong pagganap sa pamamagitan ng mga practice session, assessment, at aktibidad sa pag-aaral.",
			"mastery": "Pagkabihasa",
			"quickStats": "Mabilisang stats"
		},
		"languageLearning": {
			"proficiencyCardTitle": "Kahusayan sa {{skill}}",
			"proficiencyCardTooltip": "Kasalukuyan kang nasa {{level, lowercase}} na level sa {{skill, lowercase}}",
			"itemTypesCardSubtitle_one": "{{count}} uri ng item",
			"itemTypesCardSubtitle_other": "{{count}} uri ng item",
			"itemTypesCardTitle": "Mga item ng {{skill}}",
			"itemTypeLevelTooltip": "Kasalukuyan kang nasa {{level, lowercase}} na level sa {{skill, lowercase}} para sa mga uri ng tanong na “{{itemType}}”",
			"itemTypesFallbackTitle": "Mga uri ng item",
			"itemTypesEmptyTitle": "Hindi magagamit ang mga uri ng item",
			"itemTypesEmptySubtitle": "Hindi namin nahanap ang mga uri ng item para sa skill na ito. Bumalik sa Progreso at subukan ulit.",
			"itemTypesEmptyCta": "Bumalik sa progreso",
			"notAnswered": "Hindi nasagutan",
			"answeredSubtitle_one": "Batay sa {{count}} item na nasagot",
			"answeredSubtitle_other": "Batay sa {{count}} item na nasagot",
			"responsesSubtitle_one": "Batay sa {{count}} sagot",
			"responsesSubtitle_other": "Batay sa {{count}} sagot",
			"testsTakenSubtitle_one": "Batay sa {{count}} test na kinuha",
			"testsTakenSubtitle_other": "Batay sa {{count}} test na kinuha",
			"startFirstTest": {
				"title": "Magsimula na tayo",
				"itemsSubtitle_one": "{{count}} item",
				"itemsSubtitle_other": "{{count}} item",
				"guidance": {
					"diagnostic": "Magsimula sa isang diagnostic para malaman ang iyong mga kalakasan at iakma ang iyong study plan.",
					"sectional": "Ang sectional test ay nakatuon sa isang bahagi ng exam, kaya nakakakuha ka ng score sa mas maikling oras.",
					"fullMock": "Ang full mock test ay sumasalamin sa tunay na exam mula simula hanggang katapusan at nagbibigay sa iyo ng pinaka-kumpletong score."
				}
			},
			"noScoresTitle": "Wala pang {{skill, lowercase}} na score",
			"noScoresSubtitle": "Gawin ang iyong unang test para makita ang iyong tinatayang score at task breakdown.",
			"noScoresCta": "Simulan",
			"noScoresCardSubtitle": "Batay sa mga test na kukunin mo",
			"personalBestLabel": "Ang iyong pinakamahusay na score",
			"latestLabel": "Ang iyong pinakabago",
			"examCountdown_one": "{{count}} araw na lang bago ang iyong exam",
			"examCountdown_other": "{{count}} araw na lang bago ang iyong exam",
			"greeting": {
				"none": "Magsimula na tayo, {{firstName}}! 🚀",
				"low": "Magandang simula, {{firstName}} — magpatuloy ka! 💪",
				"medium": "Galingan mo pa, {{firstName}}! 💪",
				"high": "Malapit ka na, {{firstName}}! 🎯"
			},
			"greetingNoName": {
				"none": "Magsimula na tayo! 🚀",
				"low": "Magandang simula — magpatuloy ka! 💪",
				"medium": "Galingan mo pa! 💪",
				"high": "Malapit ka na! 🎯"
			},
			"stats": {
				"untilExam": "Petsa ng exam",
				"itemsAnswered": "Mga item na nasagot",
				"responsesAnswered": "Mga sagot"
			}
		}
	},
	"auth": {
		"incorrectPasscode": "Mali ang passcode",
		"incorrectPassword": "Mali ang password. Pakisubukang muli.",
		"passwordPlaceholder": "Ilagay ang password",
		"emailPlaceholder": "hal., dave@gmail.com",
		"verify": {
			"openEmail": "Buksan ang email para magpatuloy",
			"signInCta": "Kinukumpirma ang iyong account...",
			"signUpCta": "Ginagawa ang iyong account...",
			"contactSupport": "Hindi mo makita ang email? Tingnan ang iyong spam folder o",
			"contactSupportLink": "Makipag-ugnayan sa amin",
			"resendMagicLink": "Ipadala ulit ang magic link",
			"resendMagicLinkIn": "Ipadala ulit ang magic link sa loob ng {{time}}",
			"signInBody": "Halos tapos ka na! Kinukumpirma ang iyong mga detalye para makapag-sign in nang ligtas sa {{appName}} app.",
			"signUpBody": "Halos tapos na! Kinukumpirma namin ang iyong mga detalye para gawin ang iyong bagong {{appName}} app account.",
			"magicLinkEmail": "Nagpadala kami ng magic link sa **{{email}}**\nI-click ang link sa iyong email para makapag-sign in nang ligtas.",
			"magicLinkEmailExpiry": "Mawawalan ng bisa ang link na ito sa loob ng 10 minuto",
			"confirmEmail": "Kumpirmahin ang iyong email",
			"redirectingToApp": "Idinadala ka papunta sa {{appName}} app...",
			"appNotOpen": "Hindi nabuksan ang app? I-click ang button sa ibaba para buksan ang kaugnay na app",
			"openApp": "Buksan ang {{appName}} app",
			"installAppPrompt": "Kung walang mangyayari, siguraduhing naka-install ang {{appName}} app sa iyong device",
			"verifyAccountTitle": "Kumpirmahin ang iyong account",
			"emailResent": "Naipadala ang magic link sa {{email}}\nPakisuri ang iyong inbox, kabilang ang spam.",
			"verificationLinkExpired": "Nawalan ng bisa ang verification link",
			"verificationLinkExpiredBody": "Nawawalan ng bisa ang mga verification link pagkalipas ng 10 minuto at isang beses lang puwedeng gamitin. \nPuwede kang humiling ng bagong link sa pamamagitan ng muling pag-login",
			"accountSetupTimeoutTitle": "Hindi makumpleto ang pag-sign in",
			"accountSetupTimeoutBody": "Mas matagal kaysa inaasahan ang pag-setup ng iyong account. Pakisubukang mag-login ulit o makipag-ugnayan sa suporta kung magpapatuloy ito.",
			"loginAgain": "Mag-login ulit",
			"contactSupportExpiredLink": "Kung magpapatuloy ang isyung ito, ipaalam sa amin",
			"successTitle": "Naka-sign in ka na sa ibang tab",
			"successBody": "Isara ang tab na ito o magpatuloy mula rito",
			"successCtaLabel": "Magpatuloy dito",
			"needHelpLabel": "Kailangan ng tulong?",
			"contactSupportButton": "Makipag-ugnayan sa suporta"
		},
		"contactSupportDialog": {
			"title": "May problema sa pag-login?",
			"body": "Makipag-ugnayan sa aming suporta sa customer kung may problema ka sa pag-login, o subukan ulit",
			"cta": "I-email kami"
		},
		"emailInstruction": {
			"default": "Kung hindi ka nakatanggap ng email, tingnan ang iyong junk, spam, at recently deleted folders",
			"edu": "Kung hindi ka nakatanggap ng email, tingnan ang iyong junk, spam, at recently deleted folders, o makipag-ugnayan sa iyong IT administrator"
		},
		"createSessionLoader": {
			"configuringSession": "Inaayos ang session",
			"analyzingMastery": "Sinusuri ang pagkabihasa",
			"loadingContent": "Naglo-load ang content"
		}
	},
	"onboarding": {
		"steps": {
			"profile": {
				"title": "Ano ang itatawag namin sa iyo?",
				"description": "Lalabas ang iyong username sa mga pampublikong leaderboard habang mananatiling pribado ang iyong pangalan.",
				"usernameLabel": "Username",
				"firstNameLabel": "Unang pangalan",
				"lastNameLabel": "Apelyido",
				"avatarLabel": "Larawan ng Profile",
				"avatarTooltip": "Awtomatikong nabubuo ang mga larawan ng profile batay sa iyong username.",
				"profileSaveFailed": "Hindi namin na-save ang iyong profile. Pakisubukang muli."
			},
			"testDate": {
				"cta": "Magpatuloy"
			},
			"examDate": {
				"daysAway": "Nagbibigay iyon sa amin ng {{value}} araw. Bibigyang-priyoridad namin agad ang iyong mga pinakamahinang bahagi."
			},
			"skills": {
				"chooseAll": "Piliin ang lahat ng naaangkop"
			},
			"plan": {
				"recommended": "Inirerekomenda"
			},
			"toeicLevelOverview": {
				"title": "May simula ang lahat.",
				"description": "Tinutulungan ka ng pagsasanay na bumuo ng pagkabihasa sa isang level bago ka natural na lumago patungo sa susunod.",
				"illustrationLabel": "Pag-unlad mula sa Batayan (A1–A2) tungo sa Katamtaman (B1–B2) hanggang sa Dalubhasa (C1).",
				"levels": {
					"basic": {
						"name": "Batayan",
						"band": "A1–A2"
					},
					"intermediate": {
						"name": "Katamtaman",
						"band": "B1–B2"
					},
					"proficient": {
						"name": "Dalubhasa",
						"band": "C1"
					}
				},
				"progression": {
					"title": "Paano ka uunlad",
					"practiceSessions": "Magsanay sa mga inirerekomendang session",
					"buildMastery": "Bumuo ng pagkabihasa sa iyong kasalukuyang level",
					"growToward": "Magpatuloy sa paglago patungo sa Dalubhasa"
				},
				"levelDetails": {
					"title": "Ano ang ibig sabihin ng bawat level",
					"scoreRange": "{{band}} · iskor {{min}}–{{max}}",
					"basic": {
						"name": "Batayang Gumagamit",
						"summary": "Simpleng English sa trabaho",
						"examples": {
							"forms": "Mga form at paunawa",
							"instructions": "Mga tagubilin",
							"announcements": "Maiikling anunsyo"
						}
					},
					"intermediate": {
						"name": "Katamtamang Gumagamit",
						"summary": "Pang-araw-araw na komunikasyon sa trabaho",
						"examples": {
							"emails": "Mga email at pag-uusap",
							"customers": "Mga interaksyon sa customer",
							"followUps": "Mga follow-up sa miting"
						}
					},
					"proficient": {
						"name": "Dalubhasang Gumagamit",
						"summary": "Propesyonal at advanced na English",
						"examples": {
							"reports": "Mga komplikadong report at presentasyon",
							"negotiations": "Mga masalimuot na negosasyon",
							"highStakes": "Mga propesyonal na sitwasyong may mataas na panganib"
						}
					}
				},
				"disclaimer": "Ang mga score ng TOEIC Link ay mga gabay na naka-align sa CEFR, hindi ganap na cut score. Umuunlad nang hiwalay ang Reading at Listening — posibleng maabot mo ang iba't ibang level sa bawat kasanayan."
			},
			"review": {
				"diagnosticChoice": {
					"title": "Diagnostic: {{title}}",
					"body": "{{count}} item para malaman kung saan ka dapat mag-focus",
					"duration": "{{minutes}} minuto"
				},
				"homeChoice": {
					"title": "Galugarin nang mag-isa",
					"body": "Hindi pa handa magsimula, gagalugarin ko muna ang app"
				}
			}
		},
		"common": {
			"changeLater": "Puwede mo itong baguhin mamaya"
		},
		"actions": {
			"previous": "Bumalik",
			"finish": "Tapusin",
			"start": "Simulan",
			"continue": "Magpatuloy",
			"stepIndicator": "Hakbang {{step}} ng {{total}}"
		}
	},
	"more": {
		"profile": {
			"title": "Tungkol sa iyo"
		},
		"exam": {
			"title": "Ang iyong exam"
		},
		"subscriptions": {
			"title": "Mga Produkto",
			"redeem": {
				"title": "I-redeem ang binili"
			},
			"extend": {
				"cta": "Palawigin"
			}
		}
	},
	"examDate": {
		"noticeDialog": {
			"title": "Itakda ang iyong layuning petsa ng exam",
			"description": "Ang petsang ito ay para lang gabayan ang iyong iskedyul ng pag-aaral sa loob ng app. Hindi nito naaapektuhan ang iyong opisyal na pagpaparehistro sa exam.",
			"dismissCta": "Hindi muna",
			"confirmCta": "Itakda ang petsa ng exam"
		}
	},
	"account": {
		"title": "Setting ng Account",
		"currentExam": "Kasalukuyang exam",
		"subscriptions": "Mga Produkto",
		"examDate": "Petsa ng exam",
		"examDateUpdated": "Naitakda ang petsa ng exam sa {{date}}",
		"selectDate": "Piliin ang petsa",
		"appearance": "Hitsura",
		"features": "Mga Tampok",
		"audioPlaybackTest": "Ipakita ang dialog para subukan ang audio playback",
		"theme": "Tema",
		"selectTheme": "Piliin ang tema",
		"themeOptions": {
			"system": "Sistema",
			"light": "Maliwanag",
			"dark": "Madilim"
		},
		"accountInfo": "Impormasyon ng Account",
		"username": "Username",
		"name": "Pangalan",
		"nameNotSet": "Hindi pa nakatakda",
		"save": "I-save",
		"editUsername": {
			"title": "I-edit ang username"
		},
		"editName": {
			"title": "I-edit ang pangalan"
		},
		"email": "Email",
		"dev": "Developer",
		"sandbox": "Sandbox",
		"redoOnboarding": "Ulitin ang onboarding",
		"about": "Tungkol sa app",
		"termsOfService": "Mga Tuntunin ng Serbisyo",
		"privacyPolicy": "Patakaran sa Pagkapribado",
		"aiToolsTos": "Mga Tuntunin ng Paggamit ng AI Tools",
		"support": "Suporta",
		"supportEmailBody": "Nakikipag-ugnayan ako dahil kailangan ko ng tulong sa [  ]\n\n\n\nNarito ang ilang kapaki-pakinabang na impormasyon para mas mabilis maayos ang problema: \n\nUsername na nauugnay sa account (makikita sa settings kapag naka-login ka sa app):\n{{username}}\n\nEmail na nauugnay sa aking order (makikita sa settings kapag naka-login ka sa app):\n{{email}}\n\nOrder Number (karaniwang makikita sa receipt email na natanggap matapos bumili):\n\nMay posibilidad bang ibang pangalan o email ang nagamit noong aktwal na binili ang product? Kung gayon, pakibigay ang mga ito:\n\nUnang pangalan at apelyido:\n\nEmail:",
		"contactSupport": "Makipag-ugnayan sa suporta",
		"signOut": "Mag-sign out",
		"signOutConfirmation": "Sigurado ka bang gusto mong mag-sign out?",
		"deleteAccount": "Burahin ang account",
		"platform": "Plataporma",
		"partnerships": "Mga Kasosyo",
		"validUntil": "Mawawalan ng bisa sa {{date}}",
		"extendValidity": "Palawigin ang access",
		"redeemPurchase": "I-redeem ang binili",
		"redeemPurchaseNoneFound": "Walang binili na puwedeng i-redeem",
		"redeemPurchaseCheckFailed": "Hindi na-check ang mga binili. Pakisubukang muli.",
		"purchases": "Mga Binili",
		"frequentlyAskedQuestions": "Mga Madalas Itanong",
		"deleteFeedbackForm": {
			"placeholder": "Puna"
		}
	},
	"common": {
		"proficiencyLevelUnknown": "Kailangan pa ng datos",
		"proficiencyLevelPendingTooltip": "Sagutan ang mas maraming {{label}} item para matantya ang iyong level",
		"on": "sa",
		"gotIt": "Nakuha ko",
		"goBack": "Bumalik",
		"topic": "paksa",
		"itemCount_one": "{{count, number}} item",
		"itemCount_other": "{{count, number}} item",
		"examCount_one": "{{count}} pagsusulit",
		"examCount_other": "{{count}} pagsusulit",
		"questionCount_one": "{{count}} tanong",
		"questionCount_other": "{{count}} tanong",
		"item_one": "item",
		"item_other": "item",
		"and": "at",
		"this": "ito",
		"of": "ng",
		"knowMore": "Alamin pa",
		"proficiency": "kahusayan",
		"didNotAnswer": "Mga item na hindi mo pa nasagutan",
		"notAnswered": "Hindi nasagutan",
		"attempted": "sinubukan",
		"attempt": "pagsubok",
		"activity": "gawain",
		"performance": "Pagganap",
		"estimatedProficiency": "Tinatayang kahusayan",
		"details": "detalye",
		"keepPracticing": "magpatuloy sa pagsasanay!",
		"leaveFeedback": "Mag-iwan ng puna",
		"copiedToClipboard": "Na-copy sa clipboard",
		"eg": "hal.",
		"set": "itakda",
		"hint": "pahiwatig",
		"itemType": "uri ng item",
		"minute": "minuto",
		"minutes": "{{count}} minuto",
		"hour": "oras",
		"hours": "{{count}} oras",
		"continue": "Magpatuloy",
		"unlock": "I-unlock",
		"cancel": "Kanselahin",
		"view": "Tingnan",
		"switch": "Lumipat",
		"update": "I-update",
		"ok": "Ok",
		"yes": "Oo",
		"free": "Libre",
		"answered": "Nasagutan",
		"correct": "Tama",
		"incorrect": "Mali",
		"marked": "Minarkahan",
		"unmarked": "Hindi minarkahan",
		"skipped": "Nilaktawan",
		"skill_one": "kasanayan",
		"skill_other": "kasanayan",
		"word_one": "salita",
		"word_other": "salita",
		"submitResponse": "Isumite ang sagot",
		"viewDetails": "Tingnan ang detalye",
		"sec_one": "segundo",
		"sec_other": "segundo",
		"point_one": "puntos",
		"point_other": "puntos",
		"week": "Linggo",
		"month": "Buwan",
		"year": "Taon",
		"day": "Araw",
		"selectTestDate": "Piliin ang petsa ng exam",
		"points": "Puntos",
		"viewAll": "Tingnan lahat",
		"timeline": "Kronolohiya",
		"save": "I-save",
		"filters": {
			"selectAll": "Piliin lahat",
			"deselectAll": "Alisin lahat ng pinili",
			"selectedCount": "{{count}} napili",
			"expandSection": "Palawakin ang {{section}}",
			"collapseSection": "Itiklop ang {{section}}"
		},
		"showMore": "Ipakita pa",
		"showLess": "Ikubli",
		"expandA11yLabel": "Palawakin ang paglalarawan",
		"collapseA11yLabel": "Itiklop ang paglalarawan",
		"done": "Tapos na",
		"clearAll": "I-clear lahat",
		"clear": "I-clear",
		"datePicker": {
			"title": "Piliin ang petsa",
			"enterDateLabel": "Ilagay ang petsa",
			"enterDateRangeLabel": "Ilagay ang mga petsa",
			"dateLabel": "Petsa",
			"startDateLabel": "Petsa ng simula",
			"endDateLabel": "Petsa ng pagtatapos",
			"dateRequiredError": "Kailangan ang petsa",
			"invalidDateFormatError": "Hindi tamang format ng petsa. Gamitin ang MM/DD/YYYY",
			"startAfterEndError": "Hindi puwedeng mas huli ang petsa ng simula kaysa sa petsa ng pagtatapos",
			"endBeforeStartError": "Hindi puwedeng mas maaga ang petsa ng pagtatapos kaysa sa petsa ng simula",
			"minDateError": "Dapat {{date}} o mas huli ang petsa",
			"maxDateError": "Dapat {{date}} o mas maaga ang petsa",
			"dateRangeError": "Dapat nasa pagitan ng {{startDate}} at {{endDate}} ang petsa",
			"setDateCta": "Itakda ang petsa",
			"nextCta": "Susunod",
			"setTimeCta": "Itakda ang oras"
		}
	},
	"session": {
		"choicePercentageTooltip": "Pinili ng {{percentage}} ng mga mag-aaral ang sagot na ito.",
		"choiceCorrectA11yLabel": "Tamang sagot",
		"choiceIncorrectA11yLabel": "Maling sagot",
		"choiceNotSelectedA11yLabel": "Hindi napili",
		"moreItemsAlertDialog": {
			"title": "Mga Karagdagang Item",
			"cta": "Nakuha ko"
		},
		"results": {
			"followUps": {
				"title": "Mga Follow-up"
			},
			"summary": {
				"sessionAnalysis": "Pagsusuri ng Session",
				"itemCount_one": "{{count}} item",
				"itemCount_other": "{{count}} item",
				"skilledItemCount_one": "{{count}} {{skills}} item",
				"skilledItemCount_other": "{{count}} {{skills}} item",
				"levelPhrase_one": "mula sa {{levels}} level",
				"levelPhrase_other": "mula sa {{levels}} level",
				"message": "<bold>Magaling!</bold> Katatapos mo lang ng {{itemPhrase}} sa {{timeTaken}}.",
				"messageWithLevels": "<bold>Magaling!</bold> Katatapos mo lang ng {{itemPhrase}} $t(session.results.summary.levelPhrase, {\"count\": {{levelCount}}, \"levels\": \"{{levels}}\"}) sa {{timeTaken}}.",
				"proficiencyEstimateReady": "Ang tinatayang {{skill}} level mo ay <bold>{{currentLevel}}</bold>. Handa ka na ngayong mag-target ng <bold>{{nextLevel}}</bold>.",
				"proficiencyEstimateKeepPracticing": "Ang tinatayang {{skill}} level mo ay <bold>{{currentLevel}}</bold>. Magpatuloy sa pagsasanay bago tumuloy sa <bold>{{nextLevel}}</bold>.",
				"proficiencyEstimateHighest": "Ang tinatayang {{skill}} level mo ay <bold>{{currentLevel}}</bold>. Napakagaling!",
				"mixedLevel": "Halo-halo",
				"overallScore": "Kabuuang Score",
				"stats": {
					"itemsAttempted_one": "Nasagutang item",
					"itemsAttempted_other": "Nasagutang item",
					"pointsEarned_one": "Nakuhang puntos",
					"pointsEarned_other": "Nakuhang puntos",
					"answeredCorrectly": "Nasagot nang tama",
					"timeTaken": "Oras na ginugol",
					"target": "Tunguhin",
					"ofTotal": "ng {{total}}",
					"ofPointsTotal": "ng {{total}}",
					"skill": "Kasanayan",
					"skills": "Mga Kasanayan",
					"questionType": "Uri ng tanong",
					"questionTypes": "Mga uri ng tanong",
					"proficiencyLevel": "Level ng kahusayan",
					"proficiencyLevels": "Mga level ng kahusayan"
				}
			}
		},
		"prepBanner": {
			"audioStartsIn": "Magsisimula ang audio sa loob ng {{seconds}}s",
			"audioStartsInPlayOnce": "Magsisimula ang audio sa loob ng {{seconds}}s, isang beses lang ito tutugtog",
			"videoStartsIn": "Magsisimula ang video sa loob ng {{seconds}}s",
			"videoStartsInPlayOnce": "Magsisimula ang video sa loob ng {{seconds}}s, isang beses lang ito tutugtog",
			"recordingIn": "Magsisimula ang recording sa loob ng {{seconds}}s"
		},
		"timeOverrunBanner": {
			"message": "Ubos na ang oras. Sa tunay na exam, hindi na bibilangin sa score ang kahit anong sagot pagkatapos nito. Puwede kang magpatuloy sa pagsasanay."
		},
		"attributes": {
			"stimulus": "estimulo"
		},
		"stimulusTypes": {
			"reading": "Reading",
			"listening": "Listening",
			"speaking": "Speaking",
			"writing": "Writing",
			"image": "Larawan"
		},
		"masteryLevels": {
			"belowBasic": "Mas Mababa sa Batayan",
			"basic": "Batayan",
			"belowLowIntermediate": "Mas Mababa sa Mababang Katamtaman",
			"lowIntermediate": "Mababang Katamtaman",
			"highIntermediate": "Mataas na Katamtaman",
			"advanced": "Mahusay",
			"proficiencySubtitle": "Sa {{trademark}}, ito ay katumbas ng score na **{{minScore}}-{{maxScore}}/30**",
			"infoSectionLabel": "Impormasyon ng seksyong {{skill}}",
			"infoSectionText": {
				"Reading": "Sinusukat ng seksyong Reading ng {{trademark}} kung gaano mo kahusay basahin at maunawaan ang mga nakasulat na materyal na ginagamit sa isang akademikong kapaligiran. Kasama rito ang dalawang sipi, bawat isa ay humigit-kumulang 700 salita ang haba, na may 10 tanong bawat sipi. Aabutin ito ng humigit-kumulang 35 minuto para makumpleto ang seksyong Reading.",
				"Listening": "Ang seksyong Listening ng {{trademark}} ay dinisenyo para sukatin ang iyong kakayahang maunawaan ang mga pag-uusap at lektura sa Ingles. Kasama rito ang pakikinig para sa: pangunahing pagkaunawa, pag-unawa sa saloobin at antas ng katiyakan ng nagsasalita, at pagkonekta ng impormasyon. Aabutin ito ng humigit-kumulang 36 minuto para makumpleto ang seksyong Listening.",
				"Speaking": "Sinusukat ng seksyong Speaking ng {{trademark}} ang iyong kakayahang magsalita nang epektibo sa Ingles sa mga akademikong sitwasyon. Ang apat na tanong/gawain ay kahalintulad ng mga totoong sitwasyon na maaari mong maranasan sa loob man o labas ng silid-aralan. Aabutin ito ng humigit-kumulang 16 minuto para makumpleto ang seksyong Speaking.",
				"Writing": "Sinusukat ng seksyong Writing ng {{trademark}} ang iyong kakayahang sumulat sa Ingles sa isang akademikong setting, at iparating ang iyong mga ideya nang malinaw at maayos na pagkakaayos. Mag-type ka ng iyong mga sagot gamit ang computer keyboard at aabutin ito ng humigit-kumulang 29 minuto para makumpleto ang seksyong Writing."
			}
		},
		"itemTypes": {
			"MCSS": "Multiple choice, iisa ang piliin",
			"MCSSH": "Multiple choice, iisa ang i-highlight",
			"MCMS": "Multiple choice, higit sa isa ang piliin",
			"MCMSH": "Multiple choice, higit sa isa ang i-highlight",
			"INSERT_TEXT": "Ipasok ang text",
			"MATCH_MS": "Itugma, higit sa isa ang piliin",
			"MCSSM": "Multiple choice, itugma ang iisang piliin",
			"MCMSM": "Multiple choice, itugma ang higit sa isang piliin",
			"MCGS": "Multiple choice, piliin ang puwang",
			"MCOS": "Multiple choice, ayusin ang pagkakasunod-sunod",
			"LISTENING_REPLAY": "Ulitin ang Listening",
			"AUDIO_INPUT": "Ipasok ang audio",
			"ACADEMIC_DISCUSSION_RESPONSE": "Sagot sa akademikong talakayan",
			"INTEGRATED_WRITING_RESPONSE": "Sagot sa integrated writing"
		},
		"passageStem": {
			"itemOfTotal": "Item {{current}} ng {{total}}",
			"questionOfTotal": "Tanong {{current}} ng {{total}}",
			"stimulusCorrespondsToNextItems": "Ang sumusunod na estimulo ay may kaugnayan sa susunod na {{total}} item",
			"passage": "Sipi",
			"lecture": "Lektura",
			"professorsQuestion": "Tanong ng Propesor",
			"listen": "Makinig",
			"openPassage": "Buksan ang sipi",
			"backToItem": "Bumalik sa item",
			"notYetInserted": "Hindi pa naipasok",
			"insertedAtPosition": "Naipasok sa posisyon #{{position}}"
		},
		"hint": {
			"show": "Ipakita ang pahiwatig"
		},
		"navigation": {
			"next": "Susunod",
			"exit": "Lumabas",
			"saveAndExit": "I-save at lumabas",
			"previous": "Nakaraan",
			"skip": "Laktawan",
			"finish": "Tapusin",
			"help": "Tulong",
			"about": "Mga tip sa tanong",
			"questionsButtonLabel": "Nabigasyon ng mga tanong",
			"questionsButtonTooltip": "Pumunta sa alinmang tanong o i-review ang mga minarkahan",
			"questionsButtonActiveFiltersA11y": "Aktibong filter: {{count}}",
			"recordingInProgressTooltip": "Hindi ka puwedeng umalis sa item na ito habang isinasagawa ang recording",
			"questionNotReachedTooltip": "Hindi mo pa naaabot ang tanong na ito"
		},
		"questionTips": {
			"hideFutureLabel": "Huwag ipakita ang mga tip nang awtomatiko"
		},
		"toolbar": {
			"calculatorTooltip": "Buksan ang calculator",
			"highlightTooltip": "Pumili ng teksto para i-highlight ang mahalagang impormasyon para sa madaling reference",
			"markTooltip": "Markahan ang tanong na ito para balikan mamaya bago isumite",
			"unmarkTooltip": "I-click para alisin ang marka sa tanong na ito"
		},
		"summary": {
			"viewFullInsights": "Tingnan ang lahat ng pananaw",
			"targetTooltip": "Ang tunguhin ng pagganap para sa session na ito."
		},
		"stats": {
			"skill": "Kasanayan",
			"answered": "Nasagutan",
			"speed": "Bilis",
			"duration": "Tagal",
			"duration_tooltip": "Ang haba ng iyong naitalang sagot: {{duration}} $t(common.sec, {\"count\": {{duration}}})",
			"confidence": "Kumpiyansa",
			"pointsEarned": "Puntos",
			"word": "Salita",
			"words": "Mga salita",
			"time_taken": "{{time}} {{sec}}",
			"time_taken_tooltip": "{{time_taken}} $t(common.sec, {\"count\": {{time_taken}}}) ang tinagal mo para basahin at sagutan ang item na ito",
			"skill_tooltip": "Ang lugar ng kasanayan na sinuri para sa item na ito: {{skill}}",
			"answered_correct_tooltip": "Tama ang iyong isinumiteng sagot",
			"answered_incorrect_tooltip": "Mali ang iyong isinumiteng sagot",
			"skipped_tooltip": "Hindi ka nagsumite ng sagot para sa item na ito",
			"words_tooltip": "Bilang ng salita sa iyong nakasulat na sagot: {{count}}",
			"word_tooltip": "Bilang ng salita sa iyong nakasulat na sagot: {{count}}",
			"confidence_tooltip": "Kung gaano ka kumpiyansa noong isinumite mo ang iyong sagot",
			"points_earned_tooltip_one": "Nakakuha ka ng {{points}} puntos sa {{maximumScore}} maximum na puntos para sa item na ito",
			"points_earned_tooltip_other": "Nakakuha ka ng {{points}} puntos sa {{maximumScore}} maximum na puntos para sa item na ito",
			"challengers_tooltip": "Bilang ng mga mag-aaral na sumagot sa item na ito bago ka: {{count}}",
			"learning_mode_points_tooltip": "Puntos na nakuha sa pagsubok na ito: +{{xp}} XP",
			"pts_earned_tooltip": "Puntos na nakuha sa pagsubok na ito: {{xp}} XP"
		},
		"breakdownItemTypes": {
			"expandCta": "Palawakin ang breakdown"
		},
		"explanation": {
			"title": "Paliwanag",
			"feedback": "Puna",
			"skippedFeedbackNotice": "Nilaktawan mo ang tanong na ito, kaya hindi nabuo ang personalized na puna."
		},
		"followUps": "Mga Follow-up",
		"suggestCorrection": "Magmungkahi ng pagwawasto",
		"answer": {
			"correct": "Tama",
			"incorrect": "Mali",
			"skipped": "Nilaktawan"
		},
		"confidence": {
			"high": "Mataas",
			"medium": "Katamtaman",
			"low": "Mababa"
		},
		"endDialog": {
			"title": "Tapusin nang maaga ang session?",
			"confirmEndDiagnostic": "Sigurado ka bang gusto mong tapusin ang iyong session? Mawawala ang lahat ng progreso at kailangan mong magsimula ulit.",
			"confirmEnd": "Mayroon ka pang {{num}} {{itemLabel}} na natitira. Puwede kang tumapos na ngayon o magpatuloy sa pag-aaral para makumpleto ang mga ito.",
			"confirmEndNoAnswer": "Wala ka pang nasasagot na tanong. Sigurado ka bang gusto mo nang tumapos ngayon?",
			"confirmEndNoAnswerPositive": "Magpatuloy sa pag-aaral",
			"confirmEndNoAnswerNegative": "Tumapos na ngayon"
		},
		"permissionDialog": {
			"title": "Kailangan ang access sa mikropono",
			"descriptionWeb": "Ginagamit ng Speaking practice ang iyong mikropono. Hina-block ng iyong browser ang access para sa site na ito — i-click ang icon ng permissions sa tabi ng web address, payagan ang mikropono, pagkatapos ay subukan ulit.",
			"descriptionMobile": "Ginagamit ng Speaking practice ang iyong mikropono. Payagan ang access sa mikropono sa mga setting ng iyong device para magpatuloy.",
			"promptDescriptionWeb": "Ginagamit ng Speaking practice ang iyong mikropono. I-request ang permission at piliin ang Allow kapag tinanong ng iyong browser.",
			"blockedDescriptionWeb": "Naka-block ang access sa mikropono para sa site na ito. I-click ang icon sa tabi ng web address, payagan ang mikropono, pagkatapos ay i-request ulit ang permission.",
			"ok": "Ok",
			"cancel": "Kanselahin",
			"openSettings": "Buksan ang mga setting",
			"requestPermission": "I-request ang permission",
			"dismissAndExit": "I-dismiss at lumabas",
			"learnMore": "Alamin pa"
		},
		"audioPlaybackTestDialog": {
			"title": "Subukan ang audio playback",
			"description": "Kasama sa {{appName}} app ang maraming audio playback feature, tulad ng mga nasa estimulo, test item, at text-to-speech. Para masiguro ang pinakamagandang experience, pakisubukan ang iyong audio sa ibaba. Kapag nakumpirma mo nang gumagana ito, magpatuloy.",
			"troubleshooting": {
				"title": "Pag-aayos ng mga isyu sa audio",
				"volumeTitle": "Suriin ang volume ng device",
				"volumeDescriptionWeb": "I-adjust ang volume gamit ang mga keyboard control o system volume setting sa menu/taskbar",
				"volumeDescriptionMobile": "Gamitin ang mga volume button ng device o i-adjust sa mga system setting",
				"outputTitle": "Tiyakin ang audio output device",
				"outputDescription": "Kung gumagamit ng headphones, tiyaking maayos itong nakakonekta at napili bilang aktibong output device",
				"browserTitle": "Suriin ang audio sa browser tab",
				"browserDescription": "Hanapin ang naka-mute na speaker icon sa tabi ng tab title at i-unmute kung meron."
			},
			"skipCheck": "Laktawan ang check na ito sa susunod",
			"workingButton": "Kumpirmahin ang audio",
			"textToHear": "Dapat mong marinig: {{text}}"
		},
		"overall": "Kabuuan",
		"subskills": {
			"content": {
				"title": "Content"
			},
			"languageUse": {
				"title": "Language Use"
			},
			"organizationAndDevelopment": {
				"title": "Organization and Development"
			},
			"topicDevelopment": {
				"title": "Topic Development"
			},
			"delivery": {
				"title": "Delivery"
			}
		},
		"finalizing": {
			"title": "Tinatapos ang iyong mga resulta",
			"gradingProgress": "Sinusuri ang mga sagot..."
		}
	},
	"questionTypes": {
		"descriptions": {
			"Repeat Sentence": "Isang speaking task kung saan inuulit ng mag-aaral ang isang pangungusap na narinig niya, nang kasing-eksakto hangga't maaari.",
			"Read Aloud": "Isang speaking item kung saan binabasa nang malakas ng mag-aaral ang isang sipi para sa assessment.",
			"Describe Image": "Isang speaking task kung saan inilalarawan nang detalyado ng mag-aaral ang isang visual na estimulo.",
			"Write Essay": "Isang constructed-response task na nangangailangan ng structured na essay batay sa ibinigay na prompt.",
			"Retell Lecture": "Isang speaking task kung saan ibinubuod ng mag-aaral ang isang lektura o talk na pinakinggan niya.",
			"Summarize Group Discussion": "Isang listening task kung saan ibinubuod ng mag-aaral ang isang talakayan na may maraming nagsasalita.",
			"Answer Short Question": "Isang maikling speaking task kung saan sumasagot ang mag-aaral sa iisang maikling tanong gamit ang maigsi at tiyak na sagot.",
			"Respond to a Situation": "Isang speaking task kung saan tumutugon nang angkop ang mag-aaral sa isang inilarawang sitwasyon.",
			"Summarize Written Text": "Isang reading task kung saan ibinubuod ng mag-aaral ang isang sipi sa sarili niyang mga salita.",
			"Reorder Paragraph": "Isang reading task kung saan inaayos ng mag-aaral ang mga magulong paragraph sa tamang pagkakasunod-sunod.",
			"Fill in the Blanks (Dropdown)": "Isang reading task kung saan nakukumpleto ang bawat blank sa pamamagitan ng dropdown ng mga option.",
			"Fill in the Blanks (Type In)": "Isang listening task kung saan kailangang i-type ng mag-aaral ang nawawalang salita o maikling parirala.",
			"Fill in the Blanks (Drag and Drop)": "Isang reading task kung saan napupuno ang mga nawawalang salita sa pamamagitan ng pag-drag ng mga option papunta sa mga blank.",
			"Multiple Choice, Single Answer": "Isang multiple-choice item kung saan pumipili ang mag-aaral ng isang tamang sagot.",
			"Multiple Choice, Single Answer (Reading)": "Isang reading multiple-choice item kung saan pumipili ang mag-aaral ng isang tamang sagot.",
			"Multiple Choice, Single Answer (Listening)": "Isang listening multiple-choice item kung saan pumipili ang mag-aaral ng isang tamang sagot.",
			"Multiple Choice, Multiple Answers": "Isang item kung saan puwedeng pumili ang mag-aaral ng higit sa isang tamang sagot.",
			"Multiple Choice, Multiple Answers (Reading)": "Isang reading item kung saan puwedeng pumili ang mag-aaral ng higit sa isang tamang sagot.",
			"Multiple Choice, Multiple Answers (Listening)": "Isang listening item kung saan puwedeng pumili ang mag-aaral ng higit sa isang tamang sagot.",
			"Summarize Spoken Text": "Isang listening task kung saan sumusulat ang mag-aaral ng buod ng kanyang narinig.",
			"Highlight Correct Summary": "Isang listening task kung saan kailangang i-highlight ng mag-aaral ang buod na pinakaangkop sa audio.",
			"Select Missing Word": "Isang listening task na cloze-style kung saan pumipili ang mag-aaral ng nawawalang salita.",
			"Highlight Incorrect Words": "Isang listening task kung saan kailangang i-highlight ng mag-aaral ang mga salita sa transcript na naiiba sa audio.",
			"Write from Dictation": "Isang listening task kung saan isinusulat ng mag-aaral ang pangungusap na kanyang naririnig."
		}
	},
	"report": {
		"readFullInsights": "Basahin ang buong pananaw",
		"productName": "{{examName}} {{type}}",
		"startedAt": "Nagsimula sa {{time}}",
		"itemTypesTitle": "Paghahati ng mga uri ng item",
		"itemTypesFilterAll": "Lahat",
		"questionTypeCardTitle": "Paghahati ng mga uri ng item sa {{skill}}",
		"questionTypeCardSubtitle_one": "Batay sa {{count}} uri ng item ng {{skill}} sa session na ito",
		"questionTypeCardSubtitle_other": "Batay sa {{count}} uri ng item ng {{skill}} sa session na ito",
		"questionTypeCardAltSubtitle_one": "Batay sa {{count}} uri ng item sa session na ito",
		"questionTypeCardAltSubtitle_other": "Batay sa {{count}} uri ng item sa session na ito",
		"questionTypeRowSubtitle_zero": "Walang item na nasagutan",
		"questionTypeRowSubtitle_one": "{{count}} item na nasagutan",
		"questionTypeRowSubtitle_other": "{{count}} item na nasagutan",
		"itemTypeDetail": {
			"review_one": "I-review ang item",
			"review_other": "I-review ang item",
			"stats": {
				"answered_one": "Item na nasagutan",
				"answered_other": "Item na nasagutan",
				"avgTime": "Karaniwang oras kada item"
			}
		},
		"reviewAnswersDialog": {
			"title": "I-review ang mga sagot",
			"sections": {
				"skills": "Mga Kasanayan",
				"questionTypes": "Mga Uri ng Tanong",
				"proficiency": "Kahusayan",
				"performance": "Pagganap"
			},
			"summaryNone": "Pumili ng mga filter na may item para makapagpatuloy.",
			"summaryAll_one": "I-review ang lahat ng {{count}} sagot.",
			"summaryAll_other": "I-review ang lahat ng {{count}} sagot.",
			"summaryFiltered_one": "I-review ang {{count}} sagot na tumutugma sa {{filters}}.",
			"summaryFiltered_other": "I-review ang {{count}} sagot na tumutugma sa {{filters}}.",
			"reviewAnswers_one": "I-review ang {{count}} sagot",
			"reviewAnswers_other": "I-review ang {{count}} sagot",
			"more": "{{count}} pa"
		},
		"itemDetail": {
			"title": "I-review ang aking mga sagot",
			"filterAll": "Lahat",
			"filterCorrect": "Tama",
			"filterIncorrect": "Mali",
			"filterMarked": "Minarkahan",
			"emptyTitle": "Walang tumutugmang item",
			"emptyDescription": "Walang item sa iyong session na tumutugma sa napiling filter ({{filter}}). Subukang ayusin o i-clear ang mga filter para makakita ng mas maraming resulta.",
			"emptyCta": "I-clear ang mga filter"
		},
		"answerCardTitle": "Mga item na nasagutan",
		"answerCardSubtitle_one": "Tingnan kung paano ka nagsagot sa lahat ng {{count}} tanong",
		"answerCardSubtitle_other": "Tingnan kung paano ka nagsagot sa lahat ng {{count}} tanong",
		"skillsBreakdown": {
			"title": "Paghahati ng mga Kasanayan",
			"subtitle_one": "Batay sa {{count}} item",
			"subtitle_other": "Batay sa {{count}} item"
		},
		"studyPack": "Pakete ng Pag-aaral",
		"practiceTestCompleted": "Nakumpleto ang practice test",
		"studySessionCompleted": "Nakumpleto ang study session",
		"diagnosticSessionCompleted": "Nakumpleto ang diagnostic session",
		"timeElapsed": "Oras na lumipas",
		"stats": {
			"answered": "NASAGUTAN",
			"time elapsed": "ORAS NA LUMIPAS",
			"avg speed": "KARANIWANG BILIS",
			"hints used": "PAHIWATIG NA GINAMIT"
		},
		"pointsInfo": {
			"feedbackText": {
				"advanced": "Ang galing—magpatuloy sa paghahangad ng kahusayan!",
				"highIntermediate": "Ang galing mo—patuloy na paunlarin ang iyong mga kalakasan!",
				"lowIntermediate": "Matatag ang iyong progreso—ituloy mo lang!",
				"basic": "Magpatuloy sa pagsusumikap para mapahusay ang iyong mga kakayahan!"
			},
			"infoText": "Nakumpleto mo ang **{{numActivities}} {{activityLabel}}** para masanay ang iyong {{skillsText}} {{skills}}. {{skillDetails}}. Sa kabuuan, nakakuha ka ng **{{numPointsEarned}} sa {{numTotalPoints}} puntos**, na nagpapahiwatig ng **{{compositeLevel}} kahusayan** sa {{thisText}} {{skills}}. {{compositeFeedback}}",
			"infoText.singleSkill": "Nakumpleto mo ang **{{itemCount}} {{itemLabel}}** na nakatuon sa iyong **{{skill_1}}** kasanayan. Nakakuha ka ng **{{skill_1_score}} sa {{skill_1_total}}**, na nagpapahiwatig ng **{{proficiency}}** kahusayan. {{compositeFeedback}}",
			"infoText.multiSkill": "Nakumpleto mo ang **{{itemCount}} {{itemLabel}}**, na nagsasanay sa iyong mga kasanayan na **{{skills_text}}**. {{skill_details}} Sa kabuuan, nakakuha ka ng **{{overall_score}} sa {{overall_total}} puntos**, na nagpapahiwatig ng **{{overall_proficiency}}** kahusayan sa mga kasanayan na ito. {{compositeFeedback}}",
			"skillDetails": "Sa **{{skill}}**, nakakuha ka ng **{{score}} sa {{total}}**, na nagpapakita ng **{{proficiency}}** kahusayan."
		},
		"actions": {
			"goToHome": "Pumunta sa Bahay",
			"studyMore": "Mag-aral pa",
			"studyFree": "Mag-aral ng libreng {{tagTypes}}",
			"reviewAnswers": "I-review ang mga sagot"
		},
		"nextAction": {
			"title": "Inirerekomenda: Pagsasanay sa {{focus}}",
			"dialog": {
				"title": "Inirerekomendang study session",
				"subtitle": "Tumutok sa iyong mga kahinaan"
			},
			"fallback": {
				"title": "Magpatuloy sa pagsasanay",
				"description": "Gumawa ng study session batay sa mga bahaging gusto mong paghusayin sa susunod."
			}
		},
		"premium": {
			"upgradeCta": "Mag-upgrade sa premium"
		},
		"disclaimer": {
			"title": "Paunawa",
			"summativeBody": "Ang mga score sa practice test ay pagtatantya lamang at hindi ginagarantiyahan ang parehong resulta sa tunay na pagsusulit ng {{examName}}."
		},
		"performance": {
			"title": "Pagganap",
			"subtitle": "Batay sa {{count}} item",
			"correct": "Tama",
			"correctItems": "{{count}} item",
			"incorrect": "Mali",
			"incorrectItems": "{{count}} item"
		},
		"mastery": {
			"performanceTitle": "Pagganap",
			"sessionMasteryTitle": "Tinatayang kahusayan",
			"subtitle_assessment": "Batay sa lahat ng {{count}} {{item}} mula sa assessment na ito",
			"subtitle_session": "Batay sa lahat ng {{count}} {{item}} mula sa session na ito"
		},
		"sessionAnalysis": {
			"title": "Pagsusuri ng session",
			"subtitle": "Personalized na pagsusuri at rekomendasyon",
			"viewFullAnalysis": "Tingnan ang pagsusuri",
			"feedbackDialog": {
				"body": "Naglalabas kami ng mga bagong bersyon halos araw-araw at determinado kaming umunlad. Puwede ka bang mag-iwan ng puna?",
				"placeholder": "Ilagay ang iyong puna dito",
				"cta": "Ipadala ang puna",
				"successMessage": "Naisumite ang puna. Salamat!",
				"feedbackLimitError": "Dapat hindi bababa sa 10 karakter ang puna"
			},
			"menuActions": {
				"copy": "I-copy",
				"altCopy": "I-copy ang teksto ng buod",
				"altPositiveFeedback": "Nakatulong ito",
				"positiveFeedback": "Magandang sagot",
				"negativeFeedback": "Masamang sagot",
				"reportIssue": "I-report",
				"altReportIssue": "I-report ang sagot na ito",
				"emailSummary": "I-email ang teksto ng buod",
				"emailAlreadySent": "Naipadala na ang email",
				"copiedAnalysis": "Na-copy ang pagsusuri sa clipboard",
				"emailSent": "Naipadala ang email sa {{email}}. Kung hindi mo matanggap ang email, tingnan ang iyong mga folder na junk, spam, at recently deleted",
				"emailFailed": "Nabigong ipadala ang email sa {{email}}",
				"emailInstructionMessage": "Kung hindi mo matanggap ang email, tingnan ang iyong mga folder na junk, spam, at recently deleted, o makipag-ugnayan sa iyong IT administrator"
			}
		}
	},
	"feedback": {
		"successMessage": "Naisumite ang puna. Salamat!"
	},
	"dialog": {
		"feedback": {
			"defaultFeedbackBody": "Ano ang gusto mo? Ano ang puwedeng pagbutihin pa? Araw-araw kaming gumagawa ng mga pagpapabuti sa plataporma at binabasa ng aming koponan ang bawat puna. Salamat!",
			"title": "Ibahagi ang iyong puna",
			"body": "Ano ang gusto mo? Ano ang puwedeng pagbutihin pa? Araw-araw kaming gumagawa ng mga pagpapabuti sa plataporma at binabasa ng aming koponan ang bawat puna. **Salamat!**",
			"positiveBody": "Natutuwa kami na nakatulong ito! Sabihin sa amin **kung ano ang nagustuhan mo.**",
			"negativeBody": "Tulungan kaming maunawaan kung ano ang nangyaring mali para **mapabuti namin ang aming mga sagot.**",
			"placeholder": "Ilagay ang puna",
			"cta": "Ipadala ang puna"
		},
		"report": {
			"title": "Isumite ang report",
			"body": "Tulungan kaming maunawaan kung ano ang mali sa sagot na ito",
			"cta": "Isumite ang report"
		},
		"suggestCorrection": {
			"title": "Magmungkahi ng pagwawasto",
			"body": "Tulungan kaming mapabuti ang kawastuhan ng nilalaman na ito sa pamamagitan ng **pag-uulat ng anumang pagkakamali.**",
			"cta": "Isumite"
		},
		"feedbackReasons": {
			"negative": {
				"inaccurate": {
					"title": "Hindi tumpak",
					"description": "May maling impormasyon ang sagot"
				},
				"notHelpful": {
					"title": "Hindi nakatulong",
					"description": "Hindi tinugunan ng sagot ang aking tanong"
				},
				"incomplete": {
					"title": "Hindi kumpleto",
					"description": "Kulang ang sagot sa mahahalagang detalye"
				},
				"hardToUnderstand": {
					"title": "Mahirap unawain",
					"description": "Nakakalito o hindi malinaw ang sagot"
				},
				"other": {
					"title": "Iba pa",
					"description": "Iba pang bagay"
				}
			},
			"report": {
				"misinformation": {
					"title": "Maling impormasyon",
					"description": "May mali o nakaliligaw na impormasyon ang sagot"
				},
				"harmfulContent": {
					"title": "Nakakapinsala o nakasasakit na nilalaman",
					"description": "Hate speech, panliligalig, o hindi angkop na wika"
				},
				"violatesPolicies": {
					"title": "Lumalabag sa mga patakaran",
					"description": "Spam, sariling promosyon, o ilegal na nilalaman"
				},
				"other": {
					"title": "Iba pa",
					"description": "Tukuyin kung ano ang mali gamit ang sarili mong mga salita"
				}
			}
		},
		"faqs": {
			"title": "Mga madalas itanong",
			"body": "Narito ang ilan sa mga pinakamadalas itanong tungkol sa app. Kung mayroon kang iba pang tanong, mangyaring makipag-ugnayan sa amin sa support@memorang.ai"
		},
		"delete": {
			"title": "Burahin ang account",
			"body": "Nalulungkot kami na aalis ka na at hangad namin ang tagumpay mo sa iyong akademiko at propesyonal na paglalakbay!",
			"options": "Masyadong mahal|Natapos ko na ang test ko|Hindi ko nagustuhan ang nilalaman|Kulang ang mga tampok/paggana|Iba pa",
			"confirmdelete": {
				"title": "Kumpirmahin ang pagbura ng account",
				"cta": "Burahin",
				"errorMessage": "Paumanhin, hindi tugma ang email na iyon sa account na ito. Pakisubukan ulit",
				"successMessage": "Matagumpay na nabura ang account!",
				"validEmail": "Pakilagay ang wastong email address"
			}
		}
	},
	"recorder": {
		"tapToRecord": "Pindutin para i-record ang iyong sagot",
		"responseAudioUnavailable": "Hindi magagamit ang audio ng sagot para sa playback",
		"recording": "Nagre-record",
		"recordingCompleted": "Nakumpleto na ang pag-record",
		"getReady": "Maghanda",
		"timeIsUp": "Naubos na ang oras. Hindi na-record ang iyong sagot.",
		"alert": {
			"title": "Naabot na ang pinakamataas na tagal",
			"body": "Huminto ang pag-record dahil naabot na nito ang pinakamataas na tagal na {{maxDuration}} segundo."
		},
		"uiElementPressed": "Huminto ang pag-record - nabuksan ang estimulo habang aktibong nagre-record."
	},
	"writing": {
		"placeholder": "Isulat ang iyong sagot dito...",
		"wordCount": "{{count}} {{word}}",
		"title": "Ang iyong sagot",
		"submit": "Isumite",
		"helper": {
			"range": "Sumulat ng {{min}}–{{max}} salita para maisumite ang iyong sagot",
			"min": "Sumulat ng hindi bababa sa {{min}} salita para maisumite ang iyong sagot",
			"max": "Paikliin ang iyong sagot sa {{max}} salita o mas kaunti"
		}
	},
	"navbar": {
		"home": "Bahay",
		"progress": "Progreso",
		"insights": "Mga Pananaw",
		"leaderboard": "Ranggo",
		"store": "Tindahan",
		"more": "Higit Pa",
		"redeem": "I-redeem",
		"study-pack": "Pakete ng Pag-aaral",
		"podcasts": "Mga Podcast",
		"modules": "Mga Modyul",
		"account": "Setting ng Account",
		"accountTab": "Account",
		"privacy": "Pagkapribado",
		"terms": "Mga Tuntunin",
		"cme": "CME"
	},
	"redeem": {
		"contactSupportHint": "Tama ang pagkakalagay mo ng code pero may isyu pa rin? **Makipag-ugnayan sa support** at siguraduhing isama ang iyong access code at detalye ng pagbili",
		"olxDialog": {
			"unlockedTitle": "Na-unlock ang Access",
			"expiredTitle": "Nag-expire ang Access",
			"testInfo": "**Exam:** {{examName}} | **Test:** {{bundleName}}",
			"upcomingBody_one": "Na-unlock na ang iyong access sa OLX test!\n\nMaaari kang magsimula ng session sa loob ng **{{count}} araw**. Bumalik ulit mamaya para simulan ang iyong session mula sa Practice Tests tab.",
			"upcomingBody_other": "Na-unlock na ang iyong access sa OLX test!\n\nMaaari kang magsimula ng session sa loob ng **{{count}} araw**. Bumalik ulit mamaya para simulan ang iyong session mula sa Practice Tests tab.",
			"activeBody": "Aktibo na ngayon ang iyong access sa OLX test!\n\nMaaari kang magsimula ng session anumang oras bago mag-**{{date}}**.\n\nGusto mo bang simulan ang session ngayon o mamaya na lang?",
			"expiredBody": "Nag-expire na ang iyong access sa OLX test noong **{{date}}**.\n\nMakipag-ugnayan sa iyong propesor o school administrator para sa karagdagang tulong.",
			"startNowCta": "Simulan Ngayon",
			"startLaterCta": "Simulan sa Ibang Pagkakataon"
		},
		"unexpectedError": "May naganap na hindi inaasahang error."
	},
	"redeemCode": {
		"titleRedeem": "I-redeem ang access",
		"titleGranted": "Naibigay ang access",
		"formTitle": "Ilagay ang iyong access code",
		"accessCodeHint": "Kung mayroon kang access code, mangyaring ilagay ito dito, kasama ang mga gitling.",
		"submit": "I-redeem",
		"access": "I-access dito",
		"helpFindCode": "Kailangan mo ng tulong sa paghahanap ng iyong code?",
		"troubleRedeeming": "May problema sa pag-redeem? Tanungin ang Assistant!",
		"skipStep": "Laktawan ang hakbang na ito"
	},
	"autoRedeem": {
		"redeem": "I-redeem",
		"redeeming": "Nire-redeem...",
		"continue": "Magpatuloy",
		"unredeemedPrompt_one": "Mayroong **{{count}} product** na naka-link sa email address na **{{email}}** na hindi pa na-redeem. Gusto mo bang idagdag ito sa iyong account?",
		"unredeemedPrompt_other": "Mayroong **{{count}} product** na naka-link sa email address na **{{email}}** na hindi pa na-redeem. Gusto mo bang idagdag ito sa iyong account?",
		"successMessage_one": "Binabati kita! Na-unlock na ang **{{count}} product** sa ibaba sa iyong account. Pagkatapos pindutin ang magpatuloy, mababago ang konteksto ng iyong app para ipakita ang exam: **{{examName}}**. Puwede mong baguhin ito anumang oras mula sa setting ng iyong account kung gusto mong mag-aral para sa ibang exam o bumili ng ibang product.",
		"successMessage_other": "Binabati kita! Na-unlock na ang **{{count}} product** sa ibaba sa iyong account. Pagkatapos pindutin ang magpatuloy, mababago ang konteksto ng iyong app para ipakita ang exam: **{{examName}}**. Puwede mong baguhin ito anumang oras mula sa setting ng iyong account kung gusto mong mag-aral para sa ibang exam o bumili ng ibang product."
	},
	"olxEligibility": {
		"goToPracticeTests": "Pumunta sa Practice Tests"
	},
	"moreChallenges": {
		"challenges": "Mga Hamon",
		"challengesCount": "{{value}} Hamon"
	},
	"tts": {
		"tooltip": "Makinig"
	},
	"commandBar": {
		"placeholder": "Maghanap...",
		"input": {
			"placeholder": "Mag-type ng utos o maghanap"
		},
		"sections": {
			"quickActions": "Mga mabilisang aksyon"
		},
		"actions": {
			"changeExam": "Palitan ang exam",
			"switchToDarkMode": "Lumipat sa madilim na tema",
			"switchToLightMode": "Lumipat sa maliwanag na tema",
			"setExamDate": "Itakda ang petsa ng exam"
		}
	},
	"filterView": {
		"placeholder": "Maghanap ng exam..."
	},
	"transcript": {
		"show": "Ipakita ang transcript",
		"hide": "Itago ang transcript"
	},
	"testDriver": {
		"appBar": {
			"logoAlt": "Logo ng app",
			"testNameLabel": "Pangalan ng test",
			"sectionLabel": "Seksyon",
			"back": "Bumalik",
			"pause": "I-pause",
			"menuLabel": "Higit pang mga opsyon"
		},
		"pteSummativeAppbar": {
			"progressBarLabel": "Progreso ng test",
			"of": "ng",
			"pauseSession": "I-pause ang session",
			"timerTooltip": {
				"item": "Natitirang oras para sa tanong na ito",
				"section": "Natitirang oras sa seksyong ito",
				"test": "Natitirang oras sa test na ito"
			}
		},
		"pteSummativeBottomAppbar": {
			"next": "Susunod"
		},
		"progressBar": {
			"timeLeftLabel": "Natitirang oras para sa tanong na ito",
			"timeLeftForUnit": "Natitirang oras para sa yunit na ito",
			"questionOf": "Tanong {{current}} ng {{total}}",
			"questionProgress": "<b>{{current}}</b> ng {{total}}",
			"timesUp": "Ubos na ang oras",
			"statusTooltips": {
				"answered": "Nasagutan",
				"inProgress": "Isinasagawa",
				"skipped": "Nilaktawan",
				"notSeen": "Hindi pa nakita"
			}
		},
		"timeRemainingDialog": {
			"title": "May oras ka pa",
			"body": "May natitira pang oras sa yunit na ito. Gusto mo bang i-review ang iyong mga sagot bago isumite?",
			"reviewCta": "I-review ang aking mga sagot"
		},
		"itemTypes": {
			"reorderParagraph": {
				"sourceTitle": "Pinagmulan",
				"answerTitle": "Ang iyong sagot",
				"remainingBadge": "{{count}} natitira",
				"placedBadge": "{{count}} nailagay",
				"pointsBadge": "{{earned}}/{{max}} puntos",
				"emptyHint": "I-drag ang mga talata dito mula sa kaliwang panel"
			}
		}
	},
	"redeemCopilot": {
		"contactSupport": {
			"title": "Impormasyon ng suporta",
			"emailLabel": "Email",
			"subjectLabel": "Paksa",
			"messageBodyLabel": "Nilalaman ng mensahe",
			"appDetailsLabel": "Detalye ng app",
			"appNameLabel": "Pangalan",
			"versionLabel": "Bersyon",
			"platformLabel": "Plataporma"
		},
		"chat": {
			"assistantTitle": "{{tenantName}} Support Assistant",
			"fallbackTitle": "Chat",
			"betaWarning": "Ang AI assistant na ito ay nasa **Beta**—maaaring paminsan-minsan hindi tumpak o hindi kumpleto ang mga sagot.",
			"greeting": "Hi 👋 May problema ka ba sa pag-access sa isang produkto? Nandito ako para tumulong! Una, alamin natin ang problema. Alin sa mga sumusunod ang pinakaangkop sa iyong sitwasyon?\n\n1. May access code ako, pero parang hindi ito gumagana.\n2. Bumili ako, pero hindi ko mahanap ang aking access code.\n3. Dapat sana ay may access ako sa pamamagitan ng aking paaralan, pero hindi ko mahanap ang aking access code.\n4. Dati akong may access sa isang produkto, pero hindi ko na ito ma-access ngayon.\n\nPakilagay ang numerong tumutugma sa iyong isyu.",
			"input": {
				"label": "Mag-type ng mensahe...",
				"sendLabel": "Ipadala"
			}
		},
		"accessContent": {
			"redeemedTitle": "🎉 Matagumpay na Na-redeem",
			"previouslyRedeemedTitle": "🚀 Dati nang Na-redeem",
			"subtitle": "I-access ang iyong content dito",
			"expires": "Mawawalan ng bisa: {{date}}",
			"openCta": "Buksan"
		},
		"purchases": {
			"title": "🎉 Nakitang mga Access Code",
			"subtitle": "I-redeem para ma-access ang iyong content",
			"accessCodesLabel_one": "Access Code",
			"accessCodesLabel_other": "Mga Access Code",
			"moreCodes_one": "(+ {{count}} pa)",
			"moreCodes_other": "(+ {{count}} pa)",
			"featuresLabel": "Mga Feature",
			"redeemCta": "I-redeem"
		}
	},
	"versionChecker": {
		"banner": {
			"message": "May bagong bersyon na magagamit, i-click ang refresh para mag-update.",
			"refreshCta": "I-refresh",
			"refreshA11yLabel": "I-refresh para i-update ang app",
			"dismissTooltip": "Alisin",
			"dismissA11yLabel": "Alisin ang notipikasyon ng update"
		}
	},
	"cme": {
		"type": "Uri ng CME",
		"chooseExportMethod": "Piliin ang paraan ng pag-export",
		"selectDateRange": "Piliin ang hanay ng petsa",
		"from": "Mula",
		"to": "Hanggang",
		"sendPdfTo": "Ipadala ang pdf sa {{email}}",
		"downloadCertificate": "I-download ang Sertipiko bilang PDF",
		"amaCategory1": "AMA PRA Category 1",
		"creditEarnedSubtitle": "Nakuhang CME Credit",
		"confirmYourName": "Kumpirmahin ang iyong pangalan",
		"certificateNameNotice": "Ilalagay ang pangalang ito sa iyong Sertipiko ng CME.",
		"firstName": "Unang pangalan",
		"lastName": "Apelyido",
		"firstNamePlaceholder": "Ilagay ang iyong unang pangalan",
		"lastNamePlaceholder": "Ilagay ang iyong apelyido",
		"confirm": "Kumpirmahin",
		"creditsEarnedTitle": "Nakuhang CME",
		"creditRatioCaption": "12 Hamon = 1 CME Credit",
		"earned": "Nakuha",
		"available": "Magagamit",
		"creditsValue": "{{count}} CME",
		"exportCertificate": "I-export ang Sertipiko ng CME",
		"exportDisabledCaption": "Kailangan mong makakuha ng kahit 1 CME credit para ma-export ang iyong sertipiko",
		"viewDisclaimer": "Tingnan ang paunawa ng CME"
	}
}
